export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GestioneSamm.vue?vue&type=template&id=401bd529&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/pages/GestioneSamm.vue?vue&type=template&id=401bd529&
// module id = 916
// module chunks = 0